import 'element-plus/es/components/message/style/css';
import { ref, onMounted } from 'vue';
export default {
  name: "App",
  components: {},

  setup() {
    let timer = [];
    onMounted(() => {
      // 添加渐变背景
      document.querySelector('.app-container').classList.add('gradient-bg');
    });

    function clickBtn(e) {
      // 移除所有导航项的活跃状态
      document.querySelectorAll('.nav-item').forEach(item => {
        item.classList.remove('active');
      }); // 给当前点击的导航项添加活跃状态

      e.currentTarget.closest('.nav-item').classList.add('active');
    }

    return {
      clickBtn
    };
  }

};